import { Pipe, PipeTransform} from '@angular/core';
declare var moment:any;

@Pipe({name: 'datetime'})
export class DateTime implements PipeTransform {

	transform(list: any, pattern:string, field1: string, field2?): any {
		if(!list || !pattern || !field1) return list;
		let countrys = {
			KR:9
		}

		if(list instanceof Array){
			list.map((item:any) => {
				let date:string;
	
				if(!field2) date = item[field1];
				else date = item[field1][field2];
	
				date = moment(date, "YYYY/MM/DD HH:mm:ss").add(countrys['KR'], 'hour').format(pattern);
				
				if(!field2) item[field1] = date;
				else item[field1][field2] = date;
			});
		}else{
			let date:string;
			date = list;
			date = moment(date, "YYYY/MM/DD HH:mm:ss").add(countrys['KR'], 'hour').format(pattern);
			list = date;
		}
		
		return list;
	}
}


// WEBPACK FOOTER //
// ./src/app/pipes/date-time-pipe.ts